import { createSlice } from "@reduxjs/toolkit/"

let initialState = {
    niveauList : [],
    selectedNiveau:{},
}
const niveauSlice = createSlice({
    name:'niveau',
    initialState,
    reducers:{
        setNiveauList:(state,{payload})=>{
            state.niveauList = payload
        },
        setNiveauProfile:(state,{payload})=>{
            state.selectedNiveau = payload
        },
    }
})

export const { setNiveauList,setNiveauProfile} = niveauSlice.actions
export default niveauSlice.reducer